import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { supabase } from '@/integrations/supabase/client';

export const LiveUserCount = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const channel = supabase.channel('online-users', {
      config: { presence: { key: crypto.randomUUID() } },
    });

    channel
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState();
        setCount(Object.keys(state).length);
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({ online_at: new Date().toISOString() });
        }
      });

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  if (count < 2) return null;

  return (
    <motion.div
      className="flex items-center gap-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <span
        className="relative flex h-2 w-2"
      >
        <span
          className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
          style={{ backgroundColor: 'hsl(150, 60%, 55%)' }}
        />
        <span
          className="relative inline-flex rounded-full h-2 w-2"
          style={{ backgroundColor: 'hsl(150, 60%, 55%)' }}
        />
      </span>
      <span
        className="text-xs tracking-[0.1em]"
        style={{ color: 'hsl(150, 20%, 70%)' }}
      >
        {count} {count === 1 ? 'person' : 'people'} here now
      </span>
    </motion.div>
  );
};
